export default {
    routes: {
        // 
    }
};



// WEBPACK FOOTER //
// ./src/vendor/config/router.js